import { classes } from 'utils/style';
import styles from './HotkeyBadge.module.css';

/**
 * A small badge displaying a keyboard shortcut hint.
 * Used in navigation items and interactive elements with hotkey support.
 */
export const HotkeyBadge = ({ children, className }) => (
  <span className={classes(styles.badge, className)}>{children}</span>
);
